import React from 'react';
import Home from './pages/Home';
import './App.css';

function App() {
  return (
    <div className="App min-h-screen bg-neo-bg text-neo-text font-sans">
      <Home />
    </div>
  );
}

export default App;